<template>
  <v-radio-group
    :value="value"
    @change="$emit('input', $event)"
    dense
    class="mt-0 pt-0"
  >
    <template v-for="doc in doctorList">
      <div
        class="d-flex flex-row align-center pb-4"
        style="gap: 4px"
        :id="`radio-container-${doc.id}`"
      >
        <x-radio
          :value="doc.id"
          class="mb-0"
        >
          <template #label>
            <div class="d-flex flex-column">
              <div style="font-size: 20px; color: #2A3948">
                <span>{{ doc.name }}</span>
              </div>
              <div style="font-size: 16px; color: #999999" class="pt-1">
                {{ `Ближайшее доступное время - ${doc.closestScheduleDate} в ${doc.closestScheduleTime}` }}
              </div>
            </div>
          </template>
        </x-radio>
        <note-tooltip
          :note="doc.note"
          :attach-id="`radio-container-${doc.id}`"
        />
      </div>
    </template>
  </v-radio-group>
</template>

<script>
import XRadio from "@/components/x-env/radio/XRadio"
import NoteTooltip from "@/components/tooltip/NoteTooltip"

export default {
  components: {
    NoteTooltip,
    XRadio,
  },
  props: {
    value: String,
    doctorList: Array,
  },
}
</script>

<style scoped>

</style>